<app-data-table
  [columns]="columns"
  [data]="tableRows"
  emptyMessage="No records for the selected filters.">
</app-data-table>
